import { render, staticRenderFns } from "./ContactCard.vue?vue&type=template&id=6edc02c1&"
import script from "./ContactCard.js?vue&type=script&lang=js&"
export * from "./ContactCard.js?vue&type=script&lang=js&"
import style0 from "./ContactCard.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports